import React from 'react';

import { useTheme } from '@mui/material/styles';

interface CircularTimerSvgProps {
  size?: number;
  strokeWidth?: number;
  radius?: number;
  circumference?: number;
  offset: number;
}

export function CircularTimerSvg({
  size = 180,
  strokeWidth = 10,
  radius = 85,
  circumference = 2 * Math.PI * 85,
  offset,
}: CircularTimerSvgProps) {
  const theme = useTheme();

  return (
    <svg width={size} height={size}>
      <circle
        stroke={theme.palette.border.main}
        fill="none"
        strokeWidth={strokeWidth}
        cx={size / 2}
        cy={size / 2}
        r={radius}
      />
      <circle
        stroke={theme.palette.primary.main}
        fill="none"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        cx={size / 2}
        cy={size / 2}
        r={radius}
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
      />
    </svg>
  );
}
